import { SiteType } from '../graphql/codegen';

// ENVIRONMENT variables
export enum Environments {
  DEV = 'DEV',
  TST = 'TST',
  ACC = 'ACC',
  PRD = 'PRD',
}

export const avalaraCountries = ['us', 'ca'];

// Country ISO Code
export const CHINA_CODE = 'cn';

// Exploding View
export const componentEasing = 'power3.out';
export const calloutEasing = 'power1.out';
export const calloutDuration = '200';
export const calloutLabelDelay = 0.1;
export const animationStartDelay = 0.5;

// Style Variants
export const styleVariantsLimitForSSR = 5;

// Size Selector Button
export type SizeButtonStyle = 'normal' | 'large' | 'fourA' | 'medium' | 'sizeRange';

// Custom events
export enum CustomEventTypes {
  PLP_STATE_UPDATE = 'plpStateUpdate',
  RECENTLY_VIEWED_PRODUCTS_LIST_UPDATED = 'recentlyViewedProductsListUpdated',
  CART_ADD_ITEM_SUCCESS = 'addToBagResponseSuccess',
  YMAL_EVENT = 'ymalEvent',
  IMAGE_VIEW_MODE = 'imageViewMode',
  PRODUCT_TILE_VARIANT_HOVERED = 'productTileVariantHovered',
  IMAGE_SWITCH_CONTEXT_REQUEST = 'imageSwitchContextRequest',
  IMAGE_SWITCH_CONTEXT_RESPONSE = 'imageSwitchContextResponse',
}

const REGEX_ENV = '(dev|acc|tst|prd|docker|local)';
const REGEX_TLD = '(dev|tst|acc|prd|com)';

export const HostNameRegExps = {
  GSTAR: new RegExp(
    String.raw`^((${REGEX_ENV}\d*-www\.raw-indigo|www\.g-star)\.${REGEX_TLD}|localhost)(:\d+)?`
  ),
  AAF: new RegExp(
    String.raw`^((${REGEX_ENV}\d*-aaf\.raw-indigo|www\.appliedartforms)\.${REGEX_TLD}|aaf\.localhost)(:\d+)?`
  ),
  OUTLET: new RegExp(
    String.raw`^((${REGEX_ENV}\d*-outlet\.raw-indigo|outlet\.g-star)\.${REGEX_TLD}|outlet\.localhost)(:\d+)?`
  ),
  EMPLOYEESHOP: new RegExp(
    String.raw`^((${REGEX_ENV}\d*-employeeshop\.raw-indigo|employeeshop\.g-star)\.${REGEX_TLD}|employeeshop\.localhost)(:\d+)?`
  ),
  WAHTS: new RegExp(
    String.raw`^((${REGEX_ENV}\d*-wahts\.raw-indigo|www\.wahts)\.${REGEX_TLD}|wahts\.localhost)(:\d+)?`
  ),
};

// Page types
export enum PageTypes {
  PRODUCT = 'product',
  HOME = 'home',
  CATEGORY = 'category',
  SEARCH = 'searchresults',
  OTHER = 'other',
  CAMPAIGN = 'campaign',
  LOOKBOOK = 'lookbook',
  WISHLIST = 'wishlist',
  STORIES = 'stories',
  PDV = 'pdv',
  CUSTOMER_SERVICE = 'customer-service',
  CUSTOMER_SERVICE_RETURNS = 'customer-service-returns',
}

export const NEWSLETTER_OVERLAY_PAGE_VIEWS = 'newsletterOverlayPageviews';
export const NEWSLETTER_OVERLAY_SHOWN = 'newsletterOverlayShown';
export const NEWSLETTER_OVERLAY_START_TIME = 'newsletterOverlayStartTime';

export enum SigningTypes {
  MANUAL = 'MANUAL',
  AUTOMATIC_DISCOUNTGROUP = 'AUTOMATIC_DISCOUNTGROUP',
  AUTOMATIC_L30D_DEAL = 'AUTOMATIC_L30D_DEAL',
}
/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!!                                                                                  !!!
 * !!!        DO NOT ADD PAGES HERE UNTIL THEY ARE ACTUALLY LIVE IN PRODUCTION          !!!
 * !!!                                                                                  !!!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * A path listed here is opened client-side by every FesLink, so the CDN never gets to route it.
 * If production still serves the path from Hybris (or the CMS content is not published on the
 * PRD hub), visitors get an empty page. See FS-4940.
 *
 * Represents the list of available FES pages per site type to be handled via NextJS client-side router.
 * Navigation will work like SPA.
 *
 * If a specifc page is not added to the list, it will work like classic MPA/hard reloads.
 *
 * TODO(FS-4943): add '/customer-service' back for gstar, aaf, outlet and employeeshop when the FES
 * FAQ and Returns pages go live: after the CDN routes /customer-service to FES and the
 * content is published on the PRD Amplience hub. Restore the isNextPage tests at the same time.
 */
export const FES_PAGES: Record<SiteType, Array<string>> = {
  [SiteType.Gstar]: [
    '/',
    '/shop',
    '/search',
    '/stories',
    '/burna-boy',
    '/the-denim',
    '/lookbook',
    '/collections',
    '/wishlist',
    '/recently-viewed',
  ],
  [SiteType.Aaf]: ['/', '/shop', '/search', '/recently-viewed'],
  [SiteType.Outlet]: ['/', '/shop', '/search', '/recently-viewed'],
  [SiteType.Employeeshop]: ['/', '/shop', '/search'],
  [SiteType.Wahts]: ['/', '/shop', '/search'],
};

export const IS_DEV_WIREMOCK =
  process.env.ENVIRONMENT === Environments.DEV &&
  process.env.RUNTIME_ORIGIN === 'http://localhost:8082';

export const DEFAULT_LARGE_DESKTOP_BREAKPOINT = 1440;

export const MOBILE_VIDEO_POSITION = 2;
